export class DropdownModel {
  name: string;
  value: any;
}
